import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'app/main/services/app.service';
import { BaseLanguageLoaderComponent } from '../base-language-loader.component';

@Component({
	selector: 'notfound',
	templateUrl: './notfound.component.html',
	styleUrls: ['./notfound.component.scss']
})
export class NotFoundComponent extends BaseLanguageLoaderComponent implements OnInit, OnDestroy {

	constructor(public translate: TranslateService, public appService: AppService) {
		super(appService, translate);
	}

	ngOnInit(): void {}

	ngOnDestroy(): void{
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
